/** biome-ignore-all lint/suspicious/noArrayIndexKey: duplicated items are required for the infinite carousel loop */
/** biome-ignore-all lint/correctness/useUniqueElementIds: section navigation targets are shared intentionally */
"use client";

import { c as _c } from "react/compiler-runtime";
import Image, { type StaticImageData } from "next/image";
import { useRef } from "react";
import Bg_Dots from "~/public/assets/backgrounds/bg-dots-2.png";
import IconAngular from "~/public/assets/technologies/flowla-logo-angular.svg";
import IconAstro from "~/public/assets/technologies/flowla-logo-astro.svg";
import IconAws from "~/public/assets/technologies/flowla-logo-aws.svg";
import IconJavascript from "~/public/assets/technologies/flowla-logo-js.svg";
import IconNext from "~/public/assets/technologies/flowla-logo-next.svg";
import IconPhython from "~/public/assets/technologies/flowla-logo-phyton.svg";
import IconVue from "~/public/assets/technologies/flowla-logo-vue.svg";
import IconReact from "~/public/assets/technologies/flowla-logo-react.svg";
import IconStrapi from "~/public/assets/technologies/flowla-logo-strapi.svg";
import IconTailwind from "~/public/assets/technologies/flowla-logo-tailwind.svg";
import { TechnologyCard } from "./technology-card";
import { useTechnologiesAnimation } from "./use-technologies-animation";
const techLogos = [{
  alt: "React",
  image: IconReact,
  className: "max-w-22"
}, {
  alt: "Astro",
  image: IconAstro,
  className: "max-w-22"
}, {
  alt: "JavaScript",
  image: IconJavascript,
  className: "max-w-22"
}, {
  alt: "AWS",
  image: IconAws,
  className: "max-w-22"
}, {
  alt: "Next.js",
  image: IconNext,
  className: "max-w-22"
}, {
  alt: "Vue.js",
  image: IconVue,
  className: "max-w-22"
}, {
  alt: "Angular",
  image: IconAngular,
  className: "max-w-22"
}, {
  alt: "Strapi",
  image: IconStrapi,
  className: "max-w-22"
}, {
  alt: "Tailwind",
  image: IconTailwind,
  className: "max-w-22"
}, {
  alt: "Phython",
  image: IconPhython,
  className: "max-w-22"
}];
export type TechLogo = {
  alt: string;
  image: StaticImageData | string;
  className?: string;
};
export type TechnologySectionProps = {
  tag?: string;
  title?: string;
  description?: string;
  logos?: TechLogo[];
  isBgLight?: boolean;
};
function getLogoKey(logo: TechLogo) {
  return `${logo.alt}-${typeof logo.image === "string" ? logo.image : logo.image.src}`;
}
function buildCarouselRow(logos: TechLogo[], offset = 0) {
  const orderedLogos = [...logos.slice(offset), ...logos.slice(0, offset)];
  return [...orderedLogos, ...orderedLogos];
}
export default function TechnologySection(t0) {
  const $ = _c(56);
  const {
    tag: t1,
    title: t2,
    description: t3,
    logos: t4,
    isBgLight: t5
  } = t0;
  const tag = t1 === undefined ? "Stacks" : t1;
  const title = t2 === undefined ? "Usamos tecnologias l\xEDderes de mercado para garantir performance, seguran\xE7a e escala." : t2;
  const description = t3 === undefined ? "Trabalhamos com tecnologias amplamente adotadas, bem documentadas e com comunidade s\xF3lida, para evitar depend\xEAncia de stack ex\xF3tica ou dif\xEDcil de manter no futuro." : t3;
  const logos = t4 === undefined ? techLogos : t4;
  const isBgLight = t5 === undefined ? false : t5;
  const sectionRef = useRef(null);
  useTechnologiesAnimation(sectionRef);
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== description || $[1] !== isBgLight || $[2] !== logos || $[3] !== tag || $[4] !== title) {
    const carouselRows = [buildCarouselRow(logos), buildCarouselRow(logos, Math.ceil(logos.length / 2))];
    t14 = sectionRef;
    t15 = "technologies-section relative overflow-hidden border-b border-gray-300/80 md:container-padding";
    t16 = "technologies";
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <Image src={Bg_Dots} alt={"Imagem de fundo de pontos para decora\xE7\xE3o"} aria-hidden="true" className="absolute left-0 bottom-0 w-full h-auto max-w-[8%] 3xl:max-w-[9.8%] hidden lg:block" />;
      t18 = <Image src={Bg_Dots} alt={"Imagem de fundo de pontos para decora\xE7\xE3o"} aria-hidden="true" className="absolute right-0 bottom-0 w-full h-auto max-w-[8%] 3xl:max-w-[9.8%] hidden lg:block" />;
      $[18] = t17;
      $[19] = t18;
    } else {
      t17 = $[18];
      t18 = $[19];
    }
    t12 = "container relative z-10 pt-20 md:border-x md:border-gray-300/80 lg:pt-44 pb-28";
    let t19;
    if ($[20] !== tag) {
      t19 = <p className="tag">{tag}</p>;
      $[20] = tag;
      $[21] = t19;
    } else {
      t19 = $[21];
    }
    let t20;
    if ($[22] !== title) {
      t20 = <h2 className="title">{title}</h2>;
      $[22] = title;
      $[23] = t20;
    } else {
      t20 = $[23];
    }
    let t21;
    if ($[24] !== description) {
      t21 = description && <p className="description mt-9 max-w-3xl lg:mx-auto">{description}</p>;
      $[24] = description;
      $[25] = t21;
    } else {
      t21 = $[25];
    }
    if ($[26] !== t19 || $[27] !== t20 || $[28] !== t21) {
      t13 = <div className="mx-auto max-w-220 px-6 md:text-center">{t19}{t20}{t21}</div>;
      $[26] = t19;
      $[27] = t20;
      $[28] = t21;
      $[29] = t13;
    } else {
      t13 = $[29];
    }
    t11 = "relative mt-10 ";
    t8 = "technologies-carousel technologies-carousel-mask relative overflow-hidden py-6 md:py-8 lg:py-9";
    const t22 = `pointer-events-none absolute inset-y-0 left-0 z-20 w-18 bg-linear-to-r sm:w-28 md:w-40 lg:w-56 ${isBgLight ? "from-gray-1000/70" : "from-gray-1000/90"} to-transparent`;
    if ($[30] !== t22) {
      t9 = <span aria-hidden="true" className={t22} />;
      $[30] = t22;
      $[31] = t9;
    } else {
      t9 = $[31];
    }
    const t23 = `pointer-events-none absolute inset-y-0 right-0 z-20 w-18 bg-linear-to-l sm:w-28 md:w-40 lg:w-56 ${isBgLight ? "from-gray-1000/70" : "from-gray-1000/90"} to-transparent`;
    if ($[32] !== t23) {
      t10 = <span aria-hidden="true" className={t23} />;
      $[32] = t23;
      $[33] = t10;
    } else {
      t10 = $[33];
    }
    t6 = "flex flex-col gap-3 md:gap-6";
    t7 = carouselRows.map((rowLogos, rowIndex) => <div className="technologies-carousel-row overflow-visible" key={`technologies-row-${rowIndex}`}><div className={`technologies-carousel-track flex w-max items-stretch gap-3 motion-reduce:animate-none sm:gap-4 md:gap-6 ${rowIndex === 0 ? "technologies-carousel-track-right" : ""}`}>{rowLogos.map((logo, index) => <TechnologyCard key={`${getLogoKey(logo)}-${rowIndex}-${index}`} aria-hidden={index >= logos.length} className="min-w-44 md:w-56 lg:w-60" logo={logo} />)}</div></div>);
    $[0] = description;
    $[1] = isBgLight;
    $[2] = logos;
    $[3] = tag;
    $[4] = title;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t14;
    $[10] = t15;
    $[11] = t16;
    $[12] = t17;
    $[13] = t18;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t13 = $[8];
    t14 = $[9];
    t15 = $[10];
    t16 = $[11];
    t17 = $[12];
    t18 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  let t19;
  if ($[34] !== t6 || $[35] !== t7) {
    t19 = <div className={t6}>{t7}</div>;
    $[34] = t6;
    $[35] = t7;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t10 || $[38] !== t19 || $[39] !== t8 || $[40] !== t9) {
    t20 = <div className={t8}>{t9}{t10}{t19}</div>;
    $[37] = t10;
    $[38] = t19;
    $[39] = t8;
    $[40] = t9;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t11 || $[43] !== t20) {
    t21 = <div className={t11}>{t20}</div>;
    $[42] = t11;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t12 || $[46] !== t13 || $[47] !== t21) {
    t22 = <div className={t12}>{t13}{t21}</div>;
    $[45] = t12;
    $[46] = t13;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t14 || $[50] !== t15 || $[51] !== t16 || $[52] !== t17 || $[53] !== t18 || $[54] !== t22) {
    t23 = <section ref={t14} className={t15} id={t16}>{t17}{t18}{t22}</section>;
    $[49] = t14;
    $[50] = t15;
    $[51] = t16;
    $[52] = t17;
    $[53] = t18;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  return t23;
}